import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import store from '../';
import globals from '../../utils/globals';
import {
	CurrencyConversionServiceReadyEvent,
	LocalizedContentServiceReadyEvent
} from '@studyportals/portal-localized-content';
import { IStore } from '../../interfaces';

export class DependencyCheckerPlugin
implements ISubscriber<LocalizedContentServiceReadyEvent | CurrencyConversionServiceReadyEvent>
{
	private localizedContentServiceIsReady = false;
	private currencyConversionServiceIsReady = false;
	private store: IStore;

	constructor() {
		this.store = store;
	}

	public initiate(): void {
		const eventAggregationService = window.EventAggregationService;
		if (!eventAggregationService) {
			return;
		}

		eventAggregationService.subscribeTo(LocalizedContentServiceReadyEvent.EventType, this, true);
		eventAggregationService.subscribeTo(CurrencyConversionServiceReadyEvent.EventType, this, true);
	}

	public async notify(event: LocalizedContentServiceReadyEvent | CurrencyConversionServiceReadyEvent): Promise<void> {
		if (event.eventType === LocalizedContentServiceReadyEvent.EventType) {
			this.handleLocalizedContentServiceReadyEvent(event as LocalizedContentServiceReadyEvent);
		}

		if (event.eventType === CurrencyConversionServiceReadyEvent.EventType) {
			this.handleCurrencyConversionServiceReadyEvent(event as CurrencyConversionServiceReadyEvent);
		}

		if (this.currencyConversionServiceIsReady && this.localizedContentServiceIsReady) {
			await this.store.actions.setAreDependenciesLoaded(true);
		}
	}

	private handleLocalizedContentServiceReadyEvent(event: LocalizedContentServiceReadyEvent): void {
		globals.localizedContentService = event.localizedContentService;
		this.localizedContentServiceIsReady = true;
	}

	private handleCurrencyConversionServiceReadyEvent(event: CurrencyConversionServiceReadyEvent): void {
		globals.currencyConversionService = event.currencyConversionService;
		this.currencyConversionServiceIsReady = true;
	}
}
